var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1013)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88997 0.5L8.82735 1.29536L5.25978 5.5L3 3.1696L3.88255 2.3138L5.19924 3.67109L7.88997 0.5ZM7.88997 8L8.82735 8.79536L5.25978 13L3 10.6696L3.88255 9.8138L5.19924 11.1711L7.88997 8ZM6.75 18C6.75 17.3096 6.19036 16.75 5.5 16.75C4.80964 16.75 4.25 17.3096 4.25 18C4.25 18.6904 4.80964 19.25 5.5 19.25C6.19036 19.25 6.75 18.6904 6.75 18ZM10.5 18.625H18V17.375H10.5V18.625ZM18 11.125V9.875H10.5V11.125H18ZM18 3.625V2.375H10.5V3.625H18Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.695b62a2.svg";
export { ForwardRef as ReactComponent };